import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GameCmntItemType, GameCmntListType } from 'Interface/GameCmnt.Interface';

interface GameCmntUiProps {
    gameCmntUiInfoState: GameCmntListType;
}

const GameCmntUi = ({gameCmntUiInfoState}: GameCmntUiProps) => {
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const showFreeBrickBtn = !idntMthdCd || idntMthdCd === "NA";
    const [isCmntOpen, setIsCmntOpen] = useState(false);

    const handleToggleCmnt = () => {
        setIsCmntOpen((prev) => !prev);
    };

    const handleCmntLinkClick = () => {
        setIsCmntOpen(false);
    };

    return (
        <div className='fixedCmntOuterWrap'>
            <div className='fixedCmntWrap '>
                <div>
                    <button
                        type="button"
                        className='fixedCmntToggleBtn'
                        onClick={handleToggleCmnt}
                        aria-expanded={isCmntOpen}
                        aria-label="Toggle community links"
                    >
                        <img src={process.env.PUBLIC_URL + `/images/Cmnt/cmntWrapBtn.png`} alt="" />
                    </button>
                </div>
                <ul className={`fixedCmntUl ${isCmntOpen ? 'isOpen' : ''}`}>
                    {gameCmntUiInfoState.map((key: GameCmntItemType, index: number)=>(
                        <li key={index}>
                            <a href={key.cmntUrl} target='_blank' rel="noopener noreferrer" className={`CmntNm${key.cmntKindCd}`} onClick={handleCmntLinkClick}>
                                <img src={process.env.PUBLIC_URL + `/images/Cmnt/${key.cmntKindCd}Icon.png`} alt={key.cmntKindCd} style={{width:"40px"}}/>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            {/* {showFreeBrickBtn && (
                <div className="fixedCmntFreeBrickBtn">
                    <Link to="/MyPage/eml" className="fixedCmntFreeBrickLink">
                        <img src={process.env.PUBLIC_URL + "/images/freebrickBtn.png"} alt="" className="brickImg" />
                    </Link>
                </div>
            )} */}
        </div>
    );
};

export default GameCmntUi;